import { WorkActivityOptionsModel } from "../workActivityOptions/work-activity-option.model";

export class WorkActivityModel {
    waId: string;
    waCode: string;
    waLongName: string;
    waInactive: boolean;
    waIsSupplierTask: boolean;
    waIsClaimReserve: boolean;
    waIsPurchaseOrder: boolean;
    waIsClientTask: boolean;
    waIsInvoiceable: boolean;
    waIsReverseBilling: boolean;
    waActivityOptions: WorkActivityOptionsModel[];
}